import { catchError, map, of, tap } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { LocationDTO } from '../../../../dto/location/location.dto';
import { Location } from '../../../../models/location/Location.model';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { Router } from '@angular/router';
import { DUNA_LOCATIONS_ADMIN_EVENT } from './locations-admin-events';

export function locations_admin(componentDataSourceService: ComponentDataSourceService) {
  const router = componentDataSourceService.injector.get(Router);

  const columns = [
    { key: 'locations_name', header: 'Navn', type: 'text', sortable: true },
    {
      key: 'firefighter_count',
      header: 'Antal brandmænd',
      type: 'number',
      alignment: 'center',
      sortable: true
    },
    {
      key: 'ok_percentage',
      header: 'STATUS (%)',
      type: 'text',
      transform: (value: number) => `${value}%`,
      alignment: 'left',
      sortable: true
    },
    {
      key: 'registered_percentage',
      header: 'Tilmeldte',
      type: 'text',
      transform: (value: number, row?: any) => {
        if (value === undefined || value === null) return 'N/A';
        const intendedPercentage = Math.min(100, Math.max(0, value));
        const participatedPercentage = Math.min(100, Math.max(0, row?.progress_percentage || 0));
        return `${intendedPercentage}% (${participatedPercentage}%)`;
      },
      alignment: 'left',
      sortable: true
    },
    {
      key: 'edit',
      header: '',
      type: 'button',
      buttonText: 'Rediger',
      buttonColor: 'primary',
      variant: 'stroked',
      alignment: 'right',
      action: (item: Location) => {
        window.dispatchEvent(
          new CustomEvent(DUNA_LOCATIONS_ADMIN_EVENT, {
            detail: { entity: 'location', action: 'open-edit', row: item }
          })
        );
      }
    },
    {
      key: 'delete',
      header: '',
      type: 'button',
      buttonText: 'Slet',
      buttonColor: 'warn',
      variant: 'stroked',
      alignment: 'right',
      action: (item: Location) => {
        window.dispatchEvent(
          new CustomEvent(DUNA_LOCATIONS_ADMIN_EVENT, {
            detail: { entity: 'location', action: 'confirm-delete', row: item }
          })
        );
      }
    },
    {
      key: 'open_page',
      header: '',
      type: 'button',
      buttonText: 'Åbn side',
      buttonColor: 'accent',
      variant: 'raised',
      alignment: 'right',
      action: (item: Location) => {
        router.navigate(['/lokation', item.guid]);
      }
    }
  ];

  return {
    name: 'Lokationer (admin)',
    description: 'Alle lokationer med redigering',
    execute: (params?: LoadDataParams) => {
      return componentDataSourceService['loadDataWithStandardFiltersGET']('locations_admin', '/locations', params).pipe(
        catchError((error) => {
          console.error('Error fetching locations:', error);
          return of({ items: [], totalCount: 0 });
        }),
        map((result) => {
          if (result && result.items) {
            const locations = result.items.map((location: any) => {
              const locationDTO: LocationDTO = {
                guid: location.guid,
                locations_name: location.locations_name,
                clean_name: location.clean_name,
                data: location.data || {},
                rooms: location.rooms || [],
                users: location.users || [],
                registered_percentage: location.registered_percentage || 0,
                progress_percentage: location.progress_percentage || 0,
                ok_percentage: location.ok_percentage || 0,
                firefighter_count: location.firefighter_count || 0
              };
              return Location.fromDTO(locationDTO);
            });
            return {
              items: locations,
              totalCount: result.totalCount,
              pageSize: result.pageSize,
              pageIndex: result.pageIndex,
              filters: result.filters
            };
          }
          return { items: [], totalCount: 0 };
        })
      );
    },
    settings: {
      columns,
      pageable: true,
      sortable: true,
      rowHover: true,
      searchable: true,
      defaultSortColumn: 'locations_name',
      defaultSortDirection: 'asc'
    }
  };
}
